"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Grid = exports.Offset = exports.Cell = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var classNameGrid = function classNameGrid(props) {
  return (0, _classnames.default)('Grid', {
    'Grid--with-v-gutters': props.withVGutters,
    'Grid--with-h-gutters': props.withHGutters,
    'Grid--align-center': props.alignCenter,
    'Grid--half-v-gutters': props.halfVGutters,
    'Grid--half-h-gutters': props.halfHGutters
  }, props.className);
};

var classNameCell = function classNameCell(props) {
  return (0, _classnames.default)('Cell', "Cell--".concat(props.size), props.responsive ? props.responsive.split(',').map(function (r) {
    return "Cell--".concat(r.trim());
  }) : '', props.className);
};

var classNameOffset = function classNameOffset(props) {
  return (0, _classnames.default)('Offset', "Offset--".concat(props.size), props.responsive ? props.responsive.split(',').map(function (r) {
    return "Offset--".concat(r.trim());
  }) : '', props.className);
};

var Cell = function Cell(props) {
  var children = props.children,
      style = props.style;
  return _react.default.createElement("div", {
    className: classNameCell(props),
    style: style
  }, children);
};

exports.Cell = Cell;

var Offset = function Offset(props) {
  var children = props.children,
      style = props.style;
  return _react.default.createElement("div", {
    className: classNameOffset(props),
    style: style
  }, children);
};

exports.Offset = Offset;

var Grid = function Grid(props) {
  var children = props.children,
      style = props.style;
  return _react.default.createElement("div", {
    className: classNameGrid(props),
    style: style
  }, children);
};

exports.Grid = Grid;
var _default = Grid;
exports.default = _default;